import VueRouter from 'vue-router'
//引入组件
import  c1 from '../pages/c1'
import c2 from '../pages/c2'
import c11 from '../pages/c11'
import c12 from '../pages/c12'
import detail from '../pages/detail'
import index from '../pages/index'
import admin from '../pages/admin'
import indexHome from '../pages/index-home'
import indexArticle from '../pages/index-article'
import indexZiliao from '../pages/index-ziliao'

import adminUser from "../pages/admin-user";
import adminXueke from "../pages/admin-xueke";
import adminZiliao from "../pages/admin-ziliao";


//创建并暴露一个路由器
export default new VueRouter({
    routes:[
        {

            path:'/',
            component:index,
            redirect: "/index",
            children:[
                {
                    name:"index2",
                    path:"index",
                    component:indexHome,
                },
                {
                    path:"article",
                    component:indexArticle
                },
                {
                    name: "down",
                    path:"down",
                    component:indexZiliao
                },
            ]
        },
        {
            path:'/admin',
            component:admin,
            redirect: "/admin/a",
            children:[
                {
                    name: "admin-a",
                    path:"a",
                    component:adminUser,
                },
                {
                    path:"xueke",
                    component:adminXueke
                },
                {

                    path:"ziliao",
                    component:adminZiliao
                },
            ]

        },

        {
            path:'/c1',
            component:c1,
            children:[
                {
                    path:"c11",
                    component:c11,
                    children:[
                        {
                            path:"detail",
                            component:detail,
                        }
                    ]
                },
                {
                    path:"c12",
                    component:c12
                },

            ]
        },
        {
            path:'/c2',
            component:c2
        }
    ]
})
